import { getColourSchemeByID } from "../../../Colors/ColorPalettes";
import { formatNumber } from "../Utils/FormatNumbers";

const getadditionalTooltipContent = (data, tooltipKeys) => {
  if (tooltipKeys.length === 0) return null;
  // console.log(tooltipKeys);
  //   if (!data || !Array.isArray(tooltipKeys) || tooltipKeys.length === 0) {
  //     return null;
  //   }

  return (
    <ul>
      {tooltipKeys.map(({ responseKey, caption, numberFormat }, index) => {
        // console.log(responseKey);

        const value = Number(data[responseKey]);
        const formattedValue = formatNumber(value, numberFormat);

        return (
          <li key={index}>
            <p className="font-[400] text-gray-500">
              {`${caption} : ${formattedValue}`}
            </p>
          </li>
        );
      })}
    </ul>
  );
};
//comman color
const renderDataKey = (
  key,
  index,
  data,
  COLORS,
  currentLineIndex,
  toolTipArray,
  valueKeys = {}, // default to object
  colorMapping,
  colorMappedColor
) => {
  // console.log(colorMappedColor);
  // console.log(colorMapping, COLORS);


  const value = data[key];

  const datakey = typeof key === "string" ? key.split("|") : [];

  const lastKey = datakey[datakey.length - 1];

  // Find the full key in valueKeys that ends with the last part of the datakey
  const matchedKey = Object.keys(valueKeys).find((k) => k.endsWith(lastKey));

  const SufixPrefix = matchedKey ? valueKeys[matchedKey]?.numberFormat : null;

  const formattedValue =
    typeof value === "number" || (typeof value === "string" && !isNaN(value))
      ? formatNumber(Number(value), SufixPrefix)
      : value;

  const isBold =
    index === currentLineIndex
      ? "font-bold text-gray-900"
      : "font-normal text-gray-500";


  return (
    <div key={key} className="mb-1 flex items-center">
      <span
        className="w-3 h-3 rounded-full mr-2"
        style={{ backgroundColor: colorMappedColor }}
      />

      <p className={`font-[400] text-gray-500 ${isBold}`}>
        {`${key} : ${formattedValue}`}
      </p>
    </div>
  );
};


const renderDataKeyWithPercentage = (
  key,
  index,
  data,
  COLORS,
  currentLineIndex,
  valueKeys,
  totalKey,
  colorMapping,
  colorMappedColor
) => {
  const value = data[key];
  // console.log(valueKeys);
  const datakey = key.split("|");
  const valueKeysArray = Object.values(valueKeys);
  // console.log(valueKeysArray);
  const requiredIndex = valueKeysArray.findIndex(
    (obj) => obj.responseKey === datakey[datakey.length - 1]
  );
  const { numberFormat: SufixPrefix } = valueKeys[requiredIndex] || {};
  const totalValue = data[totalKey];
  // console.log(totalValue, totalKey);
  const formattedValue =
    typeof value === "number" || (typeof value === "string" && !isNaN(value))
      ? formatNumber(Number(value), SufixPrefix)
      : value;

  const isBold =
    index === currentLineIndex
      ? "font-bold text-gray-900"
      : "font-normal text-gray-500";
  // console.log(index, currentLineIndex);

  const shapeColor = colorMappedColor || COLORS[index];
  // console.log(shapeColor);
  // console.log(key);

  return (
    <div key={key} className="mb-1 flex items-center">
      <span
        className="w-3 h-3 rounded-full mr-2"
        style={{ backgroundColor: colorMappedColor }}
      />

      <p className={`font-[400] text-gray-500 ${isBold}`}>
        {`${key} : ${formattedValue} (${((value / totalValue) * 100).toFixed(
          1
        )}%)`}
      </p>
    </div>
  );
};


//without color renderDataKey
const renderDataKeyWithOutColor = (key, data, valueKeys = []) => {
  // console.log(valueKeys);
  // console.log(data);

  // const requiredIndex = valueKeys.findIndex(obj => obj.responseKey === key);
  const requiredIndex = valueKeys.findIndex((obj) => obj.responseKey === key);


  const value = data[key] || "null";

  // console.log(value);
  // console.log(requiredIndex);

  // console.log(key);
  // console.log(valueKeys);
  const { numberFormat: SufixPrefix } = valueKeys[requiredIndex] || {};
  // console.log(SufixPrefix);
  const formattedValue =
    typeof value === "number" || (typeof value === "string" && !isNaN(value))
      ? formatNumber(Number(value), SufixPrefix)
      : value;
  return (
    <div key={key} className="mb-1 flex items-center">
      <p className={`font-[400] text-gray-500 `}>
        {`${key} : ${formattedValue} `}
      </p>
    </div>
  );
};

//combo chart without color
const renderComboChartTooltipWithoutColor = (
  key,
  index,
  data,
  COLORS,
  currentLineIndex,
  valueKeys = {} // expected: { [key: string]: { numberFormat: string } }
) => {
  const value = data[key];

  // Get numberFormat from valueKeys
  const sufixPrefix = valueKeys[key]?.numberFormat ?? null;

  // Format value if it's a number or numeric string
  const formattedValue =
    typeof value === "number" || (typeof value === "string" && !isNaN(value))
      ? formatNumber(Number(value), sufixPrefix)
      : value;

  return (
    <div key={key} className="mb-1 flex items-center">
      <p className="font-[400] text-gray-500">
        {`${key} : ${formattedValue}`}
      </p>
    </div>
  );
};


const CustomTooltip = (props) => {
  const {
    chartType,
    active,
    payload,
    SufixPrefix,
    colorSchemeid,
    total,
    currentLineIndex,
    rowKeys = [],
    valueKeys = [],
    headerKeys = [],
    tooltipKeys = [],
    columnKeys = [],
    toolTipArray,
    colorMapping,
  } = props;
  if (!active || !payload || !payload.length) {
    return null;
  }


  const data =
    chartType === "pie" ? payload[0]?.payload?.payload : payload[0]?.payload;
  const colorScheme = getColourSchemeByID(colorSchemeid);
  const COLORS = colorScheme?.colors || ["#007a87"];
  // console.log(data);
  // console.log(payload[0]?.payload);

  let heading = null;
  let content = null;
  let additionalTooltipContent = null;
  const rowKey = rowKeys[0]?.responseKey;
  // console.log(rowKey);

  // console.log(additionalTooltipContent);

  switch (chartType) {
    case "pie": {
      //heading

      const headingValue = data[rowKey];
      heading = <span className="font-bold">{headingValue}</span>;

      //content
      const valueKeyCaption = valueKeys[0]?.caption;
      const valueResponseKey = valueKeys[0]?.responseKey;
      const value = data[valueResponseKey];
      // console.log(valueKeyCaption);
      // console.log(valueResponseKey);
      // console.log(value);

      content = (
        <p className="font-[400] text-gray-500">
          {`${valueKeyCaption} : ${formatNumber(value, SufixPrefix)} (${(
            (value / total) *
            100
          ).toFixed(1)}%)`}
        </p>
      );

      //tooltip
      // additionalTooltipContent = getadditionalTooltipContent(data, tooltipKeys);

      additionalTooltipContent = getadditionalTooltipContent(data, tooltipKeys);

      // console.log(toolTipArray);

      break;
    }
    case "line": {
      const headingKey = columnKeys[0]?.responseKey;

      const headingValue = data[headingKey];
      heading = <span className="font-bold">{headingValue}</span>;

      // console.log(rowKeys);

      rowKeys.length
        ? (content = (
          <div>
            {headerKeys.map((item, index) => {
              if (item) {
                // const colorMappedColor = colorMapping
                //   ? colorMapping[item]
                //   : COLORS[index];
                // // console.log(colorMappedColor);
                function getMatchingValue(obj, runtimeKey) {
                  // console.log(obj, runtimeKey);

                  const [runtimePrefix] = runtimeKey.split("|"); // Extract prefix before "|"

                  for (const key in obj) {
                    const [objPrefix] = key.split("|"); // Extract prefix from object's key
                    if (objPrefix === runtimePrefix) {
                      return obj[key]; // Return value if prefix matches
                    }
                  }

                  return null; // Return null if no match found
                }

                const colorMappedColor =
                  getMatchingValue(colorMapping, item) || COLORS[index];

                return renderDataKey(
                  item,
                  index,
                  data,
                  COLORS,
                  currentLineIndex,
                  toolTipArray,
                  valueKeys,

                  colorMapping,
                  colorMappedColor
                );
              }
            })}
          </div>
        ))
        : (content = (
          <div>
            {headerKeys.map((item, index) => {
              if (item) {
                // const colorMappedColor = colorMapping
                //   ? colorMapping[item]
                //   : COLORS[index];
                // // console.log(colorMappedColor);
                function getMatchingValue(obj, runtimeKey) {
                  // console.log(obj, runtimeKey);

                  const [runtimePrefix] = runtimeKey.split("|"); // Extract prefix before "|"

                  for (const key in obj) {
                    const [objPrefix] = key.split("|"); // Extract prefix from object's key
                    if (objPrefix === runtimePrefix) {
                      return obj[key]; // Return value if prefix matches
                    }
                  }

                  return null; // Return null if no match found
                }

                const colorMappedColor =
                  getMatchingValue(colorMapping, item) || COLORS[index];

                return renderDataKey(
                  item,
                  index,
                  data,
                  COLORS,
                  currentLineIndex,
                  toolTipArray,
                  valueKeys,

                  colorMapping,
                  colorMappedColor
                );
              }
            })}
          </div>
        ));

      // console.log(rowKeys);
      additionalTooltipContent = (
        <div>
          {tooltipKeys.map((item, index) => {
            // console.log(tooltipKeys);
            if (item) {
              function getMatchingValue(obj, runtimeKey) {
                // console.log(obj, runtimeKey);

                const [runtimePrefix] = runtimeKey.split("|"); // Extract prefix before "|"

                for (const key in obj) {
                  const [objPrefix] = key.split("|"); // Extract prefix from object's key
                  if (objPrefix === runtimePrefix) {
                    return obj[key]; // Return value if prefix matches
                  }
                }

                return null; // Return null if no match found
              }

              const colorMappedColor =
                getMatchingValue(colorMapping, item) || COLORS[index];
              // // console.log(colorMapping, item);
              // // console.log(colorMappedColor);

              if (rowKeys.length) {
                return renderDataKey(
                  item,
                  index,
                  data,
                  COLORS,
                  currentLineIndex,
                  toolTipArray,
                  valueKeys,
                  colorMapping,
                  colorMappedColor
                );
              } else {
                return renderDataKeyWithOutColor(item, data, toolTipArray);
              }
            }
          })}
        </div>
      );

      break;
    }
    case "bar": {
      const headingKey = columnKeys[0]?.responseKey;
      // console.log(headerKeys);

      const headingValue = data[headingKey];
      heading = <span className="font-bold">{headingValue}</span>;
      // console.log(rowKeys);

      rowKeys.length
        ? (content = (
          <div>
            {headerKeys.map((item, index) => {
              // console.log(item);

              if (item) {
                function getMatchingValue(obj, runtimeKey) {
                  // console.log(obj, runtimeKey);

                  const [runtimePrefix] = runtimeKey.split("|"); // Extract prefix before "|"
                  // console.log(runtimePrefix);
                  // console.log(runtimeKey);


                  for (const key in obj) {
                    // console.log(key, obj);

                    const [objPrefix] = key.split("|"); // Extract prefix from object's key
                    if (objPrefix === runtimePrefix) {
                      return obj[key]; // Return value if prefix matches
                    }
                  }

                  return null; // Return null if no match found
                }

                const colorMappedColor =
                  getMatchingValue(colorMapping, item) || COLORS[index];
                const arrayOfString = item.split("|");
                const totalKey = `Total ${arrayOfString[arrayOfString.length - 1]
                  }`;
                // const colorMappedColor = colorMapping
                //   ? colorMapping[item]
                //   : COLORS[index];
                // console.log(colorMappedColor);

                return renderDataKeyWithPercentage(
                  item,
                  index,
                  data,
                  COLORS,
                  currentLineIndex,
                  valueKeys,
                  totalKey,
                  colorMapping,
                  colorMappedColor
                );
              }
            })}
          </div>
        ))
        : (content = (
          <div>
            {headerKeys.map((item, index) => {
              if (item) {
                // const colorMappedColor = colorMapping
                //   ? colorMapping[item]
                //   : COLORS[index];
                // // console.log(colorMappedColor);
                function getMatchingValue(obj, runtimeKey) {
                  // console.log(obj, runtimeKey);

                  const [runtimePrefix] = runtimeKey.split("|"); // Extract prefix before "|"

                  for (const key in obj) {
                    const [objPrefix] = key.split("|"); // Extract prefix from object's key
                    if (objPrefix === runtimePrefix) {
                      return obj[key]; // Return value if prefix matches
                    }
                  }

                  return null; // Return null if no match found
                }

                const colorMappedColor =
                  getMatchingValue(colorMapping, item) || COLORS[index];

                return renderDataKey(
                  item,
                  index,
                  data,
                  COLORS,
                  currentLineIndex,
                  toolTipArray,
                  valueKeys,

                  colorMapping,
                  colorMappedColor
                );
              }
            })}
          </div>
        ));
      // console.log(headerKeys);

      additionalTooltipContent = (
        <div>
          {tooltipKeys.map((item, index) => {
            // console.log(tooltipKeys);
            if (item) {
              function getMatchingValue(obj, runtimeKey) {
                // console.log(obj, runtimeKey);

                const [runtimePrefix] = runtimeKey.split("|"); // Extract prefix before "|"

                for (const key in obj) {
                  const [objPrefix] = key.split("|"); // Extract prefix from object's key
                  if (objPrefix === runtimePrefix) {
                    return obj[key]; // Return value if prefix matches
                  }
                }

                return null; // Return null if no match found
              }

              const colorMappedColor =
                getMatchingValue(colorMapping, item) || COLORS[index];
              // // console.log(colorMapping, item);
              // // console.log(colorMappedColor);

              if (rowKeys.length) {
                return renderDataKey(
                  item,
                  index,
                  data,
                  COLORS,
                  currentLineIndex,
                  toolTipArray,
                  valueKeys,
                  colorMapping,
                  colorMappedColor
                );
              } else {
                return renderDataKeyWithOutColor(item, data, toolTipArray);
              }
            }
          })}
        </div>
      );
      // console.log(toolTipArray);

      break;
    }
    case "areachart": {
      const headingKey = columnKeys[0]?.responseKey;

      const headingValue = data[headingKey];
      heading = <span className="font-bold">{headingValue}</span>;
      // console.log(headerKeys);
      // console.log(valueKeys[0]);

      rowKeys.length
        ? (content = (
          <div>
            {headerKeys.map((item, index) => {
              if (item) {
                // const colorMappedColor = colorMapping
                //   ? colorMapping[item]
                //   : COLORS[index];
                // // console.log(colorMappedColor);
                function getMatchingValue(obj, runtimeKey) {
                  // console.log(obj, runtimeKey);

                  const [runtimePrefix] = runtimeKey.split("|"); // Extract prefix before "|"

                  for (const key in obj) {
                    const [objPrefix] = key.split("|"); // Extract prefix from object's key
                    if (objPrefix === runtimePrefix) {
                      return obj[key]; // Return value if prefix matches
                    }
                  }

                  return null; // Return null if no match found
                }

                const colorMappedColor =
                  getMatchingValue(colorMapping, item) || COLORS[index];

                return renderDataKey(
                  item,
                  index,
                  data,
                  COLORS,
                  currentLineIndex,
                  toolTipArray,
                  valueKeys,

                  colorMapping,
                  colorMappedColor
                );
              }
            })}
          </div>
        ))
        : (content = (
          <div>
            {headerKeys.map((item, index) => {
              if (item) {
                // const colorMappedColor = colorMapping
                //   ? colorMapping[item]
                //   : COLORS[index];
                // // console.log(colorMappedColor);
                function getMatchingValue(obj, runtimeKey) {
                  // console.log(obj, runtimeKey);

                  const [runtimePrefix] = runtimeKey.split("|"); // Extract prefix before "|"

                  for (const key in obj) {
                    const [objPrefix] = key.split("|"); // Extract prefix from object's key
                    if (objPrefix === runtimePrefix) {
                      return obj[key]; // Return value if prefix matches
                    }
                  }

                  return null; // Return null if no match found
                }

                const colorMappedColor =
                  getMatchingValue(colorMapping, item) || COLORS[index];

                return renderDataKey(
                  item,
                  index,
                  data,
                  COLORS,
                  currentLineIndex,
                  toolTipArray,
                  valueKeys,

                  colorMapping,
                  colorMappedColor
                );
              }
            })}
          </div>
        ));

      additionalTooltipContent = (
        <div>
          {tooltipKeys.map((item, index) => {
            // console.log(tooltipKeys);
            if (item) {
              function getMatchingValue(obj, runtimeKey) {
                // console.log(obj, runtimeKey);

                const [runtimePrefix] = runtimeKey.split("|"); // Extract prefix before "|"

                for (const key in obj) {
                  const [objPrefix] = key.split("|"); // Extract prefix from object's key
                  if (objPrefix === runtimePrefix) {
                    return obj[key]; // Return value if prefix matches
                  }
                }

                return null; // Return null if no match found
              }

              const colorMappedColor =
                getMatchingValue(colorMapping, item) || COLORS[index];
              // // console.log(colorMapping, item);
              // // console.log(colorMappedColor);

              if (rowKeys.length) {
                return renderDataKey(
                  item,
                  index,
                  data,
                  COLORS,
                  currentLineIndex,
                  toolTipArray,
                  valueKeys,
                  colorMapping,
                  colorMappedColor
                );
              } else {
                return renderDataKeyWithOutColor(item, data, toolTipArray);
              }
            }
          })}
        </div>
      );

      break;
    }
    case "scatter": {
      const headingKey = columnKeys[0]?.responseKey;
      // console.log(headingKey);
      //color
      let color = COLORS[0];
      // console.log(color);

      if (rowKey && headerKeys.length) {
        // console.log(rowKey);
        // console.log(headerKeys);
        const categoryValue = data[rowKey];
        const headerIndex = headerKeys.indexOf(categoryValue);
        // console.log(headerIndex);
        color = COLORS[headerIndex];
        // console.log(color);
        const colorMappedColor =
          getMatchingValue(colorMapping, categoryValue) || COLORS[headerIndex];

        color = colorMappedColor;
      }

      const headingValue = data[headingKey];

      function getMatchingValue(obj, runtimeKey) {
        const [runtimePrefix] = runtimeKey?.split("|") || [];

        for (const key in obj) {
          const [objPrefix] = key.split("|");
          if (objPrefix === runtimePrefix) {
            return obj[key];
          }
        }
        return null;
      }

      heading = (
        <div className="flex items-center justify-start">
          <span
            className="w-3 h-3 rounded-full mr-2"
            style={{ backgroundColor: color }}
          />
          <span className="font-bold ">{headingValue}</span>
        </div>
      );

      //key
      const valueXasixKey = valueKeys[0]?.responseKey;
      const valueYasixKey = valueKeys[1]?.responseKey;

      // create  array
      const axisKeysArray = [rowKey, valueXasixKey, valueYasixKey];

      const filteredAxisKeysArray = axisKeysArray.filter(
        (key) => key !== null && key !== undefined
      );
      // console.log(SufixPrefix);

      content = (
        <div>
          {filteredAxisKeysArray.map((item, index) =>
            renderDataKeyWithOutColor(item, data, valueKeys)
          )}
        </div>
      );
      additionalTooltipContent = (
        <div>
          {tooltipKeys.map((item, index) =>
            renderDataKeyWithOutColor(
              item.responseKey,
              data,
              tooltipKeys,
              valueKeys
            )
          )}
        </div>
      );

      // // console.log(tooltipKeys);
      break;
    }
    case "radar": {
      const headingKey = columnKeys[0]?.responseKey;
      const headingValue = data[headingKey];
      heading = <span className="font-bold ">{headingValue}</span>;

      const valueResponseKey = valueKeys[0]?.responseKey;
      // console.log(valueResponseKey);

      content = renderDataKeyWithOutColor(valueResponseKey, data, valueKeys);

      // console.log(tooltipKeys);
      additionalTooltipContent = (
        <div>
          {tooltipKeys.map((item, index) =>
            renderDataKeyWithOutColor(item.responseKey, data, tooltipKeys)
          )}
        </div>
      );
      // console.log(tooltipKeys);
      break;
    }
    case "tree":
      {
        const headingKey = columnKeys[0]?.responseKey;
        let headingValue = headingKey ? data.root?.[headingKey] : undefined;
        // // console.log(valueKeys);
        // // console.log(columnKeys);
        // // console.log(headingValue);
        // console.log(payload);

        if (headingValue === undefined) {
          headingValue = data[headingKey];
        }

        // console.log(data);
        // console.log(tooltipKeys);

        const rowKey = rowKeys[0]?.responseKey;
        const valueXasixKey = valueKeys[0]?.responseKey;

        heading = <span className="font-bold ">{headingValue}</span>;
        //key Array
        const contentKeyArray = [rowKey, valueXasixKey];
        // console.log(rowKey);
        // console.log(valueXasixKey);

        const filteredAxisKeysArray = contentKeyArray.filter(
          (key) => key !== null && key !== undefined
        );

        content = (
          <div>
            {filteredAxisKeysArray.map((item, index) =>
              renderDataKeyWithOutColor(
                item,

                data,

                valueKeys
              )
            )}
          </div>
        );
        additionalTooltipContent = (
          <div>
            {tooltipKeys.map((item, index) =>
              renderDataKeyWithOutColor(
                item.responseKey,
                data,
                tooltipKeys,

                valueKeys
              )
            )}
          </div>
        );
        // console.log(tooltipKeys);
        // console.log(data);
        // console.log(valueKeys[0]);
      }
      break;
    case "combochart":
      {
        const headingKey = columnKeys[0]?.responseKey;
        const headingValue = data[headingKey];
        // console.log(headingKey);
        // console.log(headingValue);
        // console.log(SufixPrefix);
        heading = <span className="font-bold ">{headingValue}</span>;
        content = (
          <div>
            {valueKeys.map((item, index) => {

              // console.log(item);




              function getMatchingValue(obj, runtimeKey) {
                return obj && runtimeKey?.responseKey ? obj[runtimeKey.responseKey] || null : null;
              }

              const colorMappedColor = getMatchingValue(colorMapping, item) || COLORS[index];
              // console.log(colorMappedColor);


              // console.log(colorMapping, item);
              // console.log(valueKeys);
              return renderDataKey(
                item.responseKey,
                index,
                data,
                COLORS,
                currentLineIndex,
                toolTipArray,
                valueKeys,
                colorMapping,
                colorMappedColor
              );
            }
            )}
          </div>
        );


        // console.log(tooltipKeys);

        additionalTooltipContent = (
          <div>
            {tooltipKeys.map((item, index) =>
              renderComboChartTooltipWithoutColor(
                item.responseKey,
                index,
                data,
                COLORS,
                currentLineIndex,
                tooltipKeys,
                valueKeys,
                colorMapping
              )
            )}
          </div>
        );
        // console.log(tooltipKeys);

      }

      break;


    default:
      const headingKey = columnKeys[0]?.responseKey;
      // console.log(headerKeys);
      heading = data[headingKey];
      content = null;
  }

  return (
    <div
      className="border border-gray-200 rounded bg-white p-[10px]"
      style={{
        background: "rgba(255, 255, 255, 0.9)",
        padding: "10px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div className="w-auto flex flex-col items-start justify-start text-gray-700  mb-1">
        {heading}
        {content}
        {additionalTooltipContent}
      </div>


    </div>
  );
};

export { CustomTooltip };
